import { createSelector } from 'reselect';
import { EVENTS } from '../constants/event.constants';
import { initialState } from '../reducers/event.reducer';

const selectState = state => state[EVENTS] || initialState;

export const selectEvents = () => createSelector(selectState, state => state.get('data').toList().sortBy(a => -a.get('id')));
export const selectEventsFetched = () => createSelector(selectState, state => state.get('fetched'));
export const selectOpenEvents = () => createSelector(selectState, state => state.get('data').toList().sortBy(a => -a.get('id')).filter(a => a.isOpen));